// PACKAGES
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

// MATERIAL UI
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

// COMPONENTS
import ReactLoader from "react-loader-spinner";
import Translated from "../../components/Translated/Translated";

// FILES
import api from "../../utils/api";
import {displayError} from "../../utils/toastHelper";
import translator from "../../utils/translator";
import * as actionTypes from "../../store/actions";

function ProductGroupsDialog(props) {
	const {
		warehouseNumber,
		// from state
		selectedGroupMap,
		updateSelectedGroups,
	} = props;

	const [open, setOpen] = React.useState(false);
    const [loadingDialogIsOpen, setLoadingDialogIsOpen] = useState(false);
	const [selectedGroupMapLocal, setSelectedGroupMapLocal] = useState(selectedGroupMap);

	// This is how you use states in a functional compoennt
	const [productGroups, setProductGroups] = useState([]);

	// Turn off loader once map is updated
	useEffect(() => setLoadingDialogIsOpen(false), [selectedGroupMapLocal]);

	// This function is pretty much treated as componentDidMount()
	async function loadProductGroups() {
		try {
			const { listOfProductGroups } = await api.post(
				"/products/product-groups",
				{ warehouseNumber },
			);
			setProductGroups(
				listOfProductGroups.map(
					(group) => ({
						name: group.productGroupName,
						id: group.productGroupId,
					})
				)
			);
		} catch(error) {
			displayError(error, "Error fetching product groups");
		}
	}

	const toggleGroup = async (groupId) => {
		setLoadingDialogIsOpen(true);
		// SELECT GROUP
		if (!selectedGroupMapLocal[groupId]) {
			try {
				const { products } = await api.post(
					"/products/product-group-products",
					{
						productGroupId: groupId,
						warehouseId: warehouseNumber,
					},
				);
				const newGroupMap = {
					...selectedGroupMapLocal,
					[groupId]: products,
				};
				updateSelectedGroups(newGroupMap);
				setSelectedGroupMapLocal(newGroupMap);
			} catch(error) {
				displayError(error, "Error selecting product group");
			}
		} 
		// DESELECT GROUP
		else {
			const newGroupMap = { ...selectedGroupMapLocal };
			delete newGroupMap[groupId];
			updateSelectedGroups(newGroupMap);
			setSelectedGroupMapLocal(newGroupMap);
		}
	};

	function handleClickOpen() {
		setOpen(true);
	}

	function handleClose() {
		setOpen(false);
	}

	const LoadingDialog = (
        <Dialog open={loadingDialogIsOpen} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title set-price-dialog-header">
                {translator("Product Group", "getting_products")}
            </DialogTitle>
            <DialogContent style={{ paddingRight: "10em" }}>
                <ReactLoader
                    style={{ marginLeft: "8em" }}
                    type="Oval"
                    color="#00BFFF"
                    height={50}
                    width={50}
                />
            </DialogContent>
        </Dialog>
    );
	
	useEffect(() => { loadProductGroups(); }, []);

	return (
		<div>
			<Button variant="outlined" color="primary" onClick={handleClickOpen}>
				<Translated section="Product Shopping" label="group_dialog_title" />
			</Button>
			<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					<Translated section="Product Shopping" label="group_dialog_title" />
					<Button id="set-price-close-button" onClick={handleClose} color="primary">
						<i class="fa fa-window-close fa-2x" aria-hidden="true" />
					</Button>
				</DialogTitle>
				<DialogContent>
					<DialogContentText
						style={{
							display: "grid",
							gridTemplateColumns: "auto auto auto"
						}}
					>
						<img
							style={{ display: "none" }}
							class="productImage"
							src="https://via.placeholder.com/150"
						/>
						<span><Translated section="Product Shopping" label="group_dialog_message" /></span>
					</DialogContentText>

					{LoadingDialog}
					
					<table class="table search-results-table">
						<thead id="search-projects-table-header">
							<tr>
								<th scope="col"></th>
								<th scope="col"><Translated section="Product Shopping" label="group_dialog_group_heading" /></th>
								<th scope="col"></th>
							</tr>
						</thead>
						<tbody>
							{productGroups.map((group, index) => (
								<tr class="project-search-table-row">
									<th id="tbody-header" scope="row">{index}</th>
									<td>{group.name}</td>
									<td class="table-body-buttons">
										<button
											type="button"
											class="btn btn-outline-primary copy-btn"
											onClick={() => toggleGroup(group.id)}
										>
											{translator("Misc", selectedGroupMapLocal[group.id] ? "selected_label" : "select_label")}
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</DialogContent>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	selectedGroupMap: state.selectedGroupMap,
});

const mapDispatchToProps = dispatch => {
	return {
		updateSelectedGroups: (updatedSelectedGroupMap) => dispatch({
			type: actionTypes.UPDATE_SELECTED_GROUPS,
			updatedSelectedGroupMap,
		}),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGroupsDialog);
